import type { HandleClientError } from "@sveltejs/kit/hooks";
import * as Sentry from "@sentry/sveltekit";

// If you don't want to use Session Replay, remove the `Replay` integration,
// `replaysSessionSampleRate` and `replaysOnErrorSampleRate` options.
Sentry.init({
	dsn: "https://319b076dcdc386946033ebd9d20cd853@o4506592022298624.ingest.us.sentry.io/4508697792282624",
	// tunnel: "/tunnel",
});

const onError: HandleClientError = ({ error, event }) => {
	console.error("An error occurred on the client side:", error, event);
};

// If you have a custom error handler, pass it to `handleErrorWithSentry`
export const handleError = Sentry.handleErrorWithSentry(onError);
